
export function getCookie(name: string): string | null {
  const list = typeof document !== "undefined" ? document.cookie.split("; ") : [];
  for (const item of list) {
    const [raw, ...rest] = item.split("=");
    if (decodeURIComponent(raw) === name) {
      return decodeURIComponent(rest.join("="));
    }
  }
  return null;
}
